export const TagTypes = {
  AssistantUsers: 'ASSISTANT_USERS',
  PerformanceTriangle: 'PERFORMANCE_TRIANGLE',
  PerformanceTriangleObjectives: 'PERFORMANCE_TRIANGLE_OBJECTIVES',
  ChutesConfiguration: 'CHUTES_CONFIG',
  TabletLogs: 'TABLE_LOGS',
  CameraImageSettings: 'CAMERA_IMAGE_SETTINGS',
  Clips: 'CLIPS',
};
